<template>
  <div class="tagInfo">
    <van-tabs sticky  swipeable  title-active-color="red" v-model="tabActive">
      <van-tab v-for="(tabItem,index)   in  tab" :title="tabItem.name" v-bind:key="tabItem.index">
        <!-- 基本信息列表 -->
        <div v-if="tabActive==0" class="information-flex">
          <ul  class="lists">
            <li>
              <div class="lists-item">入会时间</div>
              <div class="lists-text">{{clientInfo.baseInfo.registerDate}}</div>
            </li>
            <li>
              <div class="lists-item">是否当月生日</div>
              <div class="lists-text">{{clientInfo.baseInfo.thisMonthBirthday}}</div>
            </li>
            <li>
              <div class="lists-item">是否下月生日</div>
              <div class="lists-text">{{clientInfo.baseInfo.nextMonthBirthday}}</div>
            </li>
            <li>
              <div class="lists-item">客户类型</div>
              <div class="lists-text">{{clientInfo.baseInfo.cusType}}</div>
            </li>
            <li>
              <div class="lists-item">所属门店</div>
              <div class="lists-text">{{clientInfo.baseInfo.createDeptName}}</div>
            </li>
            <li>
              <div class="lists-item">所属店员</div>
              <div class="lists-text">{{clientInfo.baseInfo.createUserName}}</div>
            </li>
            <li>
              <div class="lists-item">客户活跃度</div>
              <div class="lists-text">{{clientInfo.baseInfo.cusActivity}}</div>
            </li>

          </ul>
        </div>
        <div v-if="tabActive==1" class="information-flex">
          <ul  class="lists">
            <li>
              <div class="lists-item">近12个月购买金额</div>
              <div class="lists-text">{{clientInfo.contribution.oneYearAmount}}</div>
            </li>
            <li>
              <div class="lists-item">累计购买金额</div>
              <div class="lists-text">{{clientInfo.contribution.amountSum}}</div>
            </li>
            <li>
              <div class="lists-item">累计购买相机数量</div>
              <div class="lists-text">{{clientInfo.contribution.cameraSum}}</div>
            </li>
            <li>
              <div class="lists-item">累计购买镜头数量</div>
              <div class="lists-text">{{clientInfo.contribution.shotSum}}</div>
            </li>
            <li>
              <div class="lists-item">平均客单价</div>
              <div class="lists-text">{{clientInfo.contribution.avgCusPrice}}</div>
            </li>
            <li>
              <div class="lists-item">购买相机客单价</div>
              <div class="lists-text">{{clientInfo.contribution.cameraCusPrice}}</div>
            </li>
            <li>
              <div class="lists-item">购买镜头客单价</div>
              <div class="lists-text">{{clientInfo.contribution.shotCusPrice}}</div>
            </li>

          </ul>
        </div>
        <div v-if="tabActive==2">
          <div  class="information-flex">
            <ul  class="lists">
              <li>
                <div class="lists-item">首次购买时间</div>
                <div class="lists-text">{{clientInfo.behaviour.firstBuy}}</div>
              </li>
              <li>
                <div class="lists-item">首次购买门店</div>
                <div class="lists-text">{{clientInfo.behaviour.firstBuyShop}}</div>
              </li>
              <li>
                <div class="lists-item">首次购买金额</div>
                <div class="lists-text">{{clientInfo.behaviour.firstBuyAmount}}</div>
              </li>
              <li>
                <div class="lists-item">首次购买相机型号</div>
                <div class="lists-text">{{clientInfo.behaviour.firstBuyCamera}}</div>
              </li>
              <li>
                <div class="lists-item">最近一次购买时间</div>
                <div class="lists-text">{{clientInfo.behaviour.latestBuyTime}}</div>
              </li>
              <li>
                <div class="lists-item">最近一次购买门店</div>
                <div class="lists-text">{{clientInfo.behaviour.latestBuyShop}}</div>
              </li>
              <li>
                <div class="lists-item">最近一次购买金额</div>
                <div class="lists-text">{{clientInfo.behaviour.latestBuyAmount}}</div>
              </li>
              </ul>
              </div>
              <hr style="background:#EcEcEc; width: 96%; height: 1px; margin: 0 auto;  border: none;">
              <div  class="information-flex">
                <ul  class="lists">
              <li>
                <div class="lists-item">最近一次跟进时间</div>
                <div class="lists-text">{{clientInfo.behaviour.latestFollowTime}}</div>
              </li>
              <li>
                <div class="lists-item">最近一次参与活动时间</div>
                <div class="lists-text">{{clientInfo.behaviour.latestActivityTime}}</div>
              </li>
              <li>
                <div class="lists-item">最近一次参与课程时间</div>
                <div class="lists-text">{{clientInfo.behaviour.latestDurationTime}}</div>
              </li>
            </ul>
          </div>

        </div>

      </van-tab>
    </van-tabs>

  </div>
</template>
<script>

export default {
  name: "",
  props: {
    // 在该视图上的高度
    custId: {
      type: String,
      default: ''
    }

  },
  data() {
    return {
      clientInfo:{
        baseInfo:{},
        behaviour:{},
        contribution:{},
      },
       taginfo: {},
       tabActive:0,
       tab:[
         {
           name: "基本信息标签",
           select:true,
           key:'basics'
         },
         {
           name: "价值贡献标签",
           select:true,
           key:'contribution'
         },
         {
           name: "客户行为标签",
           select:true,
           key:'behavior'
         },
       ]
    };
  },
  methods: {
      queryInfo(custId){
        let that=this;
          this.custId=custId;
          this.$api.get("api/tagTable/all",{
            salesId:this.$wxuserUtil.getUserId(),
            custId:custId
          }).then(res => {
            if(res.success){
              that.clientInfo=res.data;
              that.changTab(that.tabActive);
              console.log('tagTable',res);
            }
          });
      },
      changTab(index){
        this.tabActive=index;
      },
  },
  mounted() {
  },
  created() {}
};
</script>



<style lang="less" scoped>
.tagInfo{
  transition: height .5s;
  -moz-transition: height .5s;	/* Firefox 4 */
  -webkit-transition: height .5s;	/* Safari 和 Chrome */
  -o-transition: height .5s;	/* Opera */
  display: flex;
  flex-direction: column;
  min-height:.0rem;
  overflow: hidden;
  .information-flex {
    padding: 0.3rem 0.5rem;
    .lists {
      li {
              display: flex;
              //    justify-content: space-between;
              -ms-flex-item-align: center;
              align-items: center;
              min-height: 0.8rem;
              word-break: break-all;
      /* word-wrap: break-word; */
              -webkit-line-clamp: 2;
              white-space:normal;
              text-overflow: ellipsis;
      }
      .lists-item {
        width: 5rem;
        white-space: nowrap;
        color: #7e7e7e;
        font-size: 0.35rem;
      }
      .lists-text {
        font-size: 0.35rem;
        color: #4d4d4d;
        width:6rem;
      }
    }
  }
}
.van-tabs__nav--card{
    border-bottom: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/client/childCompoents/tagInfo.vue